import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=316295c2"
import script from "./CustomerHeader.vue?vue&type=script&lang=js"
export * from "./CustomerHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=316295c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports